import { useState } from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import { Plus, X } from "lucide-react";
import { useTranslationApp } from "../../../lib/i18next";
import {
  TEMPLATES_ADD_SLIDE,
  TEMPLATES_DELETE_SLIDE,
  TEMPLATES_SLIDE_LABEL,
} from "../../../i18n/keysTranslations";
import { artboardChipSx } from "./ArtboardSwitcher";

const ContinuousSlideChips = ({
  slideCount,
  disabled,
  canAdd,
  canRemove,
  onCenter,
  onAdd,
  onRemove,
}) => {
  const { t } = useTranslationApp();
  const theme = useTheme();
  const [focusedIndex, setFocusedIndex] = useState(null);
  const addDisabled = disabled || !canAdd;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        flexWrap: "wrap",
      }}
    >
      {Array.from({ length: slideCount }, (_, index) => {
        const active = index === focusedIndex;
        return (
          <Box
            key={index}
            component="button"
            type="button"
            onClick={() => {
              setFocusedIndex(index);
              onCenter?.(index);
            }}
            sx={artboardChipSx({ active, disabled: false, theme })}
          >
            {t(TEMPLATES_SLIDE_LABEL, { index: index + 1 })}
            {canRemove && !disabled ? (
              <Box
                component="span"
                onClick={(event) => {
                  event.stopPropagation();
                  onRemove?.(index);
                }}
                sx={{
                  display: "inline-flex",
                  ml: 0.25,
                  opacity: 0.8,
                  "&:hover": { opacity: 1 },
                }}
                title={t(TEMPLATES_DELETE_SLIDE)}
              >
                <X size={12} />
              </Box>
            ) : null}
          </Box>
        );
      })}
      <Box
        component="button"
        type="button"
        disabled={addDisabled}
        onClick={() => {
          if (addDisabled) return;
          onAdd?.();
        }}
        sx={artboardChipSx({
          active: false,
          disabled: addDisabled,
          theme,
        })}
        title={t(TEMPLATES_ADD_SLIDE)}
      >
        <Plus size={14} />
        {t(TEMPLATES_ADD_SLIDE)}
      </Box>
    </Box>
  );
};

export default ContinuousSlideChips;
